<template>
  <div v-cloak class="catalogue conten bg-white">
    <div class="absole"></div>
    <div class="playVideoBox videoBox">
      <play-video
        ref="palyVd"
        :playerOptions="playerOptions"
        :timer="timer"
        :cid="cid"
        :vid="vid"
        :gid="gid"
      ></play-video>
      <div class="describe padding0-15 column start-cen bg-white">
        <p class="ft16 gray-2 titleBox">{{ course.courseTitle }}</p>
        <p class="ft12 gray-8 titleBox">
          {{ course.startTime }} 至 {{ course.endTime }} |
          {{ course.ccount }}课时
        </p>
      </div>
    </div>

    <!-- <em class="video-close"  @click="showVideo">weqweqweq</em> -->
    <chapter-list
      @chapterEmit="chapterEmit"
      :catalogueData="catalogueData"
      :outline="outline"
      :catalog="catalog"
      @replaceVideo="replaceVideo"
      :time="time"
    ></chapter-list>
  </div>
</template>

<script>
import ChapterList from "@/components/list/chapterList";
import PlayVideo from "../../components/video/playVideo";
import { getCourseCatalog, getvideoInfo } from "@/model/learn/learnServer";
import { store } from "@/observable/store";
import {toLookOneVideoPag} from "@/model/player/player"
import { Dialog } from "vant";

export default {
  name: "catalogue",
  data() {
    return {
      course: {},
      outline: "",
      catalog: "",
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "http://webxiaozhu.oss-cn-beijing.aliyuncs.com/Course/%E4%BF%AE%E6%94%B9%E5%90%8E02-%E7%8E%B0%E5%9C%A8%E4%B8%8D%E5%AD%A6BIM%E5%B0%86%E6%9D%A5%E5%8F%91%E5%B1%95%E5%A5%BD%E5%90%97.mp4",
          },
        ],
        poster: "",

        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试~", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      catalogueData: [],
      timer: 0,
      gid: 0,
      vid: 0,
      cid: 0,
      time:0
    };
  },
  components: {
    ChapterList,
    PlayVideo,
  },
  computed: {
    getUserType() {
      let userType = 1;
      let videoSrc = "";
      if (userType === 1) {
        videoSrc =
          "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm";
      } else if (userType === 2) {
        videoSrc =
          "http://www.17sucai.com/preview/501914/2017-08-04/%E9%A1%B5%E9%9D%A2/media/mov_bbb.mp4";
      }
      return videoSrc;
    },
    tokenPhone() {
      return store.tokenPhone;
    },
  },
  created() {
    if (this.tokenPhone) this.$store.commit("Login/editIsUser", true);
    this.outline = this.$route.query.outline;
    this.catalog = this.$route.query.catalog;
    this.gid = this.$route.query.gid * 1;
    this.vid = this.$route.query.vid * 1;
    this.cid = this.$route.query.cid * 1;
    getCourseCatalog({
      cid: this.cid,
    }).then((res) => {
      this.course = res.data.course
      res.data.glist.forEach(element => {
        element.list.forEach(item => {
          let hour = item.timelength.substring(0, 2);
          let minute = item.timelength.substring(3, 5);
          let second = item.timelength.substring(6, 8) * 1;
          item.totalTime = hour * 60 * 60 + minute * 60 + second;
          if (item.totalTime < item.maxprogress + 5  ) {
            item.watchType = true;
          } else {
            item.watchType = false;
          }
        })
      });
      this.catalogueData = res.data.glist;
    });
    this.toLookOneVideoPag()
  },
  methods: {
    replaceVideo(pojo){
      this.time = this.$refs.palyVd.time
      if((pojo.totalTime - 10) < this.time) pojo.watchType = true
    },
    toLookOneVideoPag(data){
      let msg = {
        vid : !this.isNotNull(data) ? this.vid : data.vid,
        cid : this.cid,
        gid : !this.isNotNull(data) ? this.gid : data.gid
      }
      toLookOneVideoPag(msg).then(res => {
        if(res.data == '暂未购买课程，不可观看') {
          Dialog.alert({
            title:"提示",
            message: res.data,
          })
            .then(() => {
              this.$router.replace({
                path: "/",
              });
            })
        } else {
          this.$refs.palyVd.num = 0
          this.playerOptions.sources[0].src = res.data.vurl;
          this.timer = res.data.latelyprogress
        }
      }).catch(() => {
         Dialog.alert({
            title:"提示",
            message: "发生错误,请重新尝试",
          })
            .then(() => {
              this.$router.replace({
                path: "/",
              });
            })
      })
    },
    chapterEmit(e) {
      this.showVideo(e);
    },
    showVideo(e) {
      if(e.type == '1') this.$refs.palyVd.addUserVideoStatusAndLog();
      let videoSrc = "";
      let videoCover = this.course.videoCover;
      let data = {
        cid: this.cid * 1,
        gid: e.item.gid,
        vid: e.itm.vid,
      };
      this.cid = data.cid
      this.gid = data.gid
      this.vid = data.vid
      getvideoInfo(data).then((res) => {
        videoSrc = res.data.vurl;
        this.timer = res.data.latelyprogress;
        this.$refs.palyVd.num = 0;
        this.$refs.palyVd.showVideo(videoSrc, videoCover);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.absole {
  height: 280/20rem;
  width: 100%;
  background: black;
}
.palyVideo {
  width: 100%;
  height: 210/20rem;
  background: black;
}
.playVideoBox {
  width: 100%;
  height: 210/20rem;
  position: relative;
  z-index: 500;
}
.videoBox {
  position: fixed;
  top: 0;
  left: 0;
}
.describe {
  height: 70/20rem;
}
</style>
